var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.591,
    height: 17.5,
    viewBox: "0 0 14.591 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-pin",
    "data-name": "Location Pin",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.591,8.045c0,5.091-6.545,9.455-6.545,9.455S4.5,13.136,4.5,8.045a6.545,6.545,0,1,1,13.091,0Z",
    transform: "translate(-4.5 -1.5)",
    fill: "none",
    stroke: "#8b8b8b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.864,12.682A2.182,2.182,0,1,1,15.682,10.5a2.182,2.182,0,0,1,2.182,2.182Z",
    transform: "translate(-9.136 -6.136)",
    fill: "none",
    stroke: "#8b8b8b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.2887287b58d0efeb1c3cf04c38752a73.svg";
export { ForwardRef as ReactComponent };